import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { CONSTANTS } from '../../CONSTANTS';
import { useTranslation } from 'react-i18next';
import TextLabel from '../../components/TextLabel';

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        boxShadow: theme.shadows[1],
        marginTop: '-15px'
    },
}));




const StyledTooltip = (props: any) => {
    const { t } = useTranslation();
    let roleLabel = '';
    switch (props.adminRole) {
        case CONSTANTS.SUPER_ADMIN_USER:
            roleLabel = t('adminDashboard.roles.superAdmin') || '';
            break;
        case CONSTANTS.SUPERVISOR_USER:
            roleLabel = t('adminDashboard.roles.supervisor') || '';
            break;
        case CONSTANTS.FL_TRAINER:
            roleLabel = t('adminDashboard.roles.flTrainer') || '';
            break;
        case CONSTANTS.FL_KEY_USER:
            roleLabel = t('adminDashboard.roles.flKeyUser') || '';
            break;
        case CONSTANTS.AREA_KEY_USER:
            roleLabel = t('adminDashboard.roles.areaKeyUser') || '';
            break;
        default:
            roleLabel = '';
    }
    return(
    <LightTooltip
        title={
            <TextLabel type='smallText'>
                {roleLabel}
            </TextLabel>
        }
        arrow
        {...props}
        placement='top'
    >
        {props.children}
    </LightTooltip>
)}

export default StyledTooltip;